import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { registerChunkLoadRecovery } from './app/chunkLoadRecovery';
import { queryClient } from './lib/queryClient';
import { router } from './app/router';
import { AuthProvider } from './features/auth/AuthProvider';
import './styles/tokens.css';
import './styles/base.css';
import './styles/utilities.css';
import './styles/utilitiesResponsive.css';
import './styles/quantityFeedback.css';
import './styles/dialog.css';
import './features/units/units.css';

registerChunkLoadRecovery({
  target: window,
  storage: window.sessionStorage,
  reload: () => window.location.reload(),
  buildId: import.meta.url,
});

const root = document.getElementById('root');

if (!root) {
  throw new Error('Manjka korenski element aplikacije.');
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
